import { HOTEL_PAGE_SEARCH_REQUEST_TIMEOUT } from '@/js/common/Constants/hotelPageSearchConstants';
import getABTestValue from '@/js/common/Domain/Service/getABTestValue';
import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => requestService({
    cache: false,
    timeout: HOTEL_PAGE_SEARCH_REQUEST_TIMEOUT,
    url: `${window.appConfig.apiGatewayUrl}/frontend/hotelOffers`,
    data: {
        ...tourCriteriaForTourRequest,
        allOffersPerHotel: 1,
        sections: ['countries', 'rooms', 'operators', 'firstPaymentDefinitions', 'cancellationPolicies'],
        abTests: getABTestValue(),
    },
}, callback);